import { render, staticRenderFns } from "./settingController.vue?vue&type=template&id=8ff2d214&"
import script from "./settingController.vue?vue&type=script&lang=ts&"
export * from "./settingController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports